import { useGlobalStore } from '@stores/globalStore'
import { useLocalizationStore } from '@stores/localizationStore'

import { capitalize } from '@scripts/formatters/string'

const translator = (key: string, isCapitalize: boolean = false) => {
  const globalStore = useGlobalStore()
  const localizationStore = useLocalizationStore()

  const preparedTranslation = localizationStore.translations[globalStore.getCurrentLanguage]
    && localizationStore.translations[globalStore.getCurrentLanguage][key]

  if (!preparedTranslation) {
    return key
  }

  return isCapitalize
    ? capitalize(preparedTranslation)
    : preparedTranslation
}

export default translator
